import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useMemo } from 'react';
import { useElementSize } from './useElementSize';
export var Breakpoint = /*#__PURE__*/function (Breakpoint) {
  Breakpoint[Breakpoint["Small"] = 320] = "Small";
  Breakpoint[Breakpoint["Large"] = Infinity] = "Large";
  return Breakpoint;
}({});

/** Get the current breakpoint of the element. */
export function useElementBreakpoints() {
  var smallBreakpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Breakpoint.Small;
  var _useElementSize = useElementSize(),
    _useElementSize2 = _slicedToArray(_useElementSize, 2),
    setElement = _useElementSize2[0],
    width = _useElementSize2[1].width;
  var breakpoint = width < smallBreakpoint ? smallBreakpoint : Breakpoint.Large;
  return useMemo(function () {
    return [setElement, {
      breakpoint: breakpoint,
      isSmall: breakpoint <= smallBreakpoint,
      isLarge: breakpoint > smallBreakpoint
    }];
  }, [breakpoint, setElement, smallBreakpoint]);
}